import { Modal } from 'antd'
import React, { memo } from 'react'

interface ModalProp {
    isOpen: boolean
    closeModal: (isClose: boolean) => void
}
const ModalFilterTable: React.FC<ModalProp> = ({ isOpen, closeModal }) => {
    return (
        <Modal
            open={isOpen}
            title={false}
            footer={false}
            closeIcon={false}
            onCancel={() => closeModal(false)}
            className="w-modal-242"
        >
            <div className={`d-flex flex-column shadow-dropdown-fliter`}>
                {/* {
                    !checkShowSearch ? <></>
                        : <div className="p-1">
                            <Input
                                placeholder="Tìm kiếm "
                                allowClear
                                onChange={(e) => handleSearch(e.target.value)}
                                onClear={() => handleSearch(undefined)}
                            />
                        </div>
                } */}

                <div
                    // className={`d-flex flex-column gap-2 pl-4 py-3  ${sLData.length >= 7 ? "h-230-px overflow-y-scroll" : ""}`}
                    className={`d-flex flex-column gap-2 pl-4 py-3 `}
                >
                    {/* {
                        sLData.map((item, i) => (
                            <Checkbox
                                key={i}
                                checked={selectedValueTmp.includes(item.id)}
                                onChange={(e) => {
                                    const checked = e.target.checked;
                                    const newValue = item.id;
                                    if (checked) {
                                        setSelectedValueTmp(prev => [...prev, newValue]);
                                    } else {
                                        setSelectedValueTmp(prev => prev.filter(id => id !== newValue));
                                    }
                                }}
                                className="size-check-box size-check-box-inner p-checkbox icon-check-box">
                                <span className="text-sm font-regular fw-400">{item.title}</span>
                            </Checkbox>
                        ))
                    } */}




                </div>
                <div className='d-flex justify-between p-2 border-t-F0F0F0'>
                    <button
                        // onClick={() => setSelectedValueTmp([])}
                        // className={`${selectedValueTmp.length ? 'text-c40d0d' : 'text-BFBFBF'} border-none bg-white text-sm font-regular `} >
                        className={`text-BFBFBF border-none bg-white text-sm font-regular `} >
                        Làm mới
                    </button>
                    <button
                        onClick={() => closeModal(false)}
                        className='border-none bg-096DD9 text-sm rounded-2 h-8 px-7-px font-regular text-white'>
                        Xác nhận
                    </button>
                </div>
            </div>

        </Modal>
    )
}

export default memo(ModalFilterTable) 